// import { Injectable } from '@angular/core';
// import { AngularEditorConfig } from '@kolkov/angular-editor';

// @Injectable({
//   providedIn: 'root'
// })
// export class EditorConfigService {

//   editorConfig: AngularEditorConfig = {
//     editable: true,
//       spellcheck: true,
//       height: 'auto',
//       minHeight: '0',
//       maxHeight: 'auto',
//       width: 'auto',
//       minWidth: '0',
//       translate: 'yes',
//       enableToolbar: true,
//       showToolbar: true,
//       placeholder: 'Enter text here...',
//       defaultParagraphSeparator: '',
//       defaultFontName: '',
//       defaultFontSize: '',
//       fonts: [
//         {class: 'arial', name: 'Arial'},
//         {class: 'times-new-roman', name: 'Times New Roman'},
//         {class: 'calibri', name: 'Calibri'},
//         {class: 'comic-sans-ms', name: 'Comic Sans MS'}
//       ],
//       customClasses: [
//       {
//         name: 'quote',
//         class: 'quote',
//       },
//       {
//         name: 'redText',
//         class: 'redText'
//       },
//       {
//         name: 'titleText',
//         class: 'titleText',
//         tag: 'h1',
//       },
//     ],
//     // uploadUrl: 'v1/image',
//     // upload: (file: File) => {  }
//     // uploadWithCredentials: false,
//     // sanitize: true,
//     // toolbarPosition: 'top',
//     // toolbarHiddenButtons: [
//     //   ['bold', 'italic'],
//     //   ['fontSize']
//     // ]
//   };
// }


import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EditorConfigService {

  editorModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],

      [{ header: [1, 2, 3, false] }],

      [{ list: 'ordered' }, { list: 'bullet' }],

      [{ script: 'sub' }, { script: 'super' }],

      [{ indent: '-1' }, { indent: '+1' }],

      [{ direction: 'rtl' }],

      [{ size: ['small', false, 'large', 'huge'] }],

      [{ color: [] }, { background: [] }],

      [{ font: [] }],

      [{ align: [] }],

      ['clean'],

      ['link', 'image', 'video']
    ]
  };

  editorPlaceholder = 'Enter text here...';
}